import { ProjcetNotesWrapper, NotesList, NoteItem } from './styles';

const ProjectNotes = ({ resNotes }) => {
  return (
    <ProjcetNotesWrapper>
      <NotesList>
        {resNotes.map((note, index) => (
          <NoteItem key={index}>{note}</NoteItem>
        ))}
      </NotesList>
    </ProjcetNotesWrapper>
  );
};

export default ProjectNotes;
